import { useTranslation } from '@repo/roche-xx-shared';

export interface SearchAriaLabels {
  pagination: {
    navigationLabel: string;
    previousPageLabel: string;
    nextPageLabel: string;
    pageLabel: string;
    currentPageLabel: string;
    pageStatusLabel: string;
  };
  siteSearch: string;
  searchInputLabel: string;
  searchInputDescription: string;
  clearSearchTerm: string;
  searchingFor: string;
  noResultsFoundFor: string;
  resultsFoundFor: string;
}

export const useSearchAriaLabels = (): SearchAriaLabels => {
  const ariaSearchPagination = useTranslation('search pagination');
  const ariaPreviousPage = useTranslation('previous page');
  const ariaNextPage = useTranslation('next page');
  const ariaPage = useTranslation('page');
  const ariaCurrentPage = useTranslation('current page');
  const ariaPageStatus = useTranslation('{current} page of {total} pages');
  const ariaSiteSearch = useTranslation('search site');
  const ariaSearchLabel = useTranslation('search');
  const ariaSearchInputDescription = useTranslation('type to search the site, press escape to clear');
  const ariaClearSearchTerm = useTranslation('clear search term');
  const ariaSearchingFor = useTranslation('searching for {searchQuery}');
  const ariaNoResultsFoundFor = useTranslation('no results found for {searchQuery}');
  const ariaResultsFoundFor = useTranslation('{totalResults} results found for {searchQuery}');

  return {
    pagination: {
      navigationLabel: ariaSearchPagination,
      previousPageLabel: ariaPreviousPage,
      nextPageLabel: ariaNextPage,
      pageLabel: ariaPage,
      currentPageLabel: ariaCurrentPage,
      pageStatusLabel: ariaPageStatus,
    },
    siteSearch: ariaSiteSearch,
    searchInputLabel: ariaSearchLabel,
    searchInputDescription: ariaSearchInputDescription,
    clearSearchTerm: ariaClearSearchTerm,
    searchingFor: ariaSearchingFor,
    noResultsFoundFor: ariaNoResultsFoundFor,
    resultsFoundFor: ariaResultsFoundFor,
  };
};
